import { FilterDataSources } from "../constants/FilterDataSources";
import { FilterOperators } from "../constants/FilterOperators";
import { ServiceResponse } from "../models/ServiceResponse";
import { TaskTypeService } from "../services/TaskTypeService";
import { UserService } from "../services/UserService";
import { PriorityService } from "../services/PriorityService";
import { StatusService } from "../services/StatusService";
import { CommonFiltersArguments } from "../utilities/CommonFiltersArguments";
import { FiltersExpressions } from "../constants/FiltersExpressions";

export class DataSourceService {

    private taskTypeService = new TaskTypeService();
    private userService = new UserService();
    private priorityService = new PriorityService();
    private statusService = new StatusService();

    getDataSource(dataSource: string | null, isAutoComplete: boolean): Promise<ServiceResponse<any>> {
        if (isAutoComplete) {
            return this.getEmptyDataPromise();
        }
        if (dataSource === FilterDataSources.Priorities) {
            return this.priorityService.getPriorities();
        }
        else if (dataSource === FilterDataSources.Statuses) {
            return this.statusService.getStatuses();
        }
        else if (dataSource === FilterDataSources.Binary) {
            let data = [{ Code: "true", Name: "Yes" }, { Code: "false", Name: "No" }];
            return this.getDataPromise(data);
        }
        else {
            return this.getEmptyDataPromise();
        }
    }

    filterDataSource(dataSource: string, searchTerm: string): Promise<ServiceResponse<any>> {
        if (dataSource === FilterDataSources.Users) {
            let getByFiltersArguments = CommonFiltersArguments.getAutoCompleteFilters(["FirstName", "LastName"], searchTerm, FilterOperators.Contains);
            return this.userService.getUsersByFilters(getByFiltersArguments);
        } else if (dataSource === FilterDataSources.TaskTypes) {
            let getByFiltersArguments = CommonFiltersArguments.getAutoCompleteFilters(["Name"], searchTerm, FilterOperators.Contains);
            getByFiltersArguments.Filters.push(CommonFiltersArguments.getInActiveTaskTypeFilter());
            getByFiltersArguments.FiltersExpression = FiltersExpressions.And;
            return this.taskTypeService.getTaskTypesByFilters(getByFiltersArguments);
        }
        else {
            return this.getEmptyDataPromise();
        }
    }

    private getEmptyDataPromise(): Promise<ServiceResponse<any>> {
        return new Promise((resolve) => {
            resolve({ Data: [], TotalCount: 0, FilteredDataCount: 0, ErrorMessages: [] });
        });
    }

    private getDataPromise(data: any): Promise<ServiceResponse<any>> {
        return new Promise((resolve) => {
            resolve({ Data: data, TotalCount: 0, FilteredDataCount: 0, ErrorMessages: [] });
        });
    }

}